<template>
  <v-dialog
    :model-value="Boolean(value)"
    @update:model-value="onDialogUpdate"
    fullscreen
    content-class="dialog-fullscreen-overlay"
  >
    <div
      class="dialog-fullscreen"
    >
      <slot name="prepend"></slot>
      <v-card
        color="transparent"
        rounded="0"        flat
      >
        <v-toolbar
          dark
          color="primary"
          density="compact"
        >
          <v-btn
            icon
            dark
            @click="$emit('input', null)"
            size="small"
          >
            <v-icon size="small">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <slot></slot>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialogFullscreen',

  inheritAttrs: false,

  props: {
    value: {},
    title: {
      type: String,
      default: "",
    },
  },

  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },

  methods: {
    onDialogUpdate(isOpen) {
      if (!isOpen) {
        this.$emit('input', null);
      }
    },
  },
};
</script>

<style scoped>
.dialog-fullscreen {
  height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.85);
  /*backdrop-filter: blur(2px); This property breaks position fixed in Contact Filter Condition Editor */
}
.theme--dark .dialog-fullscreen,
.v-theme--dark .dialog-fullscreen {
  background: rgba(0, 0, 0, 0.85);
}
</style>

<style>
.dialog-fullscreen-overlay {
  overflow-x: hidden !important;
  max-width: 100vw;
  width: 100%;
}
</style>
